export const THEME_COLORS = {
  // primary
  primary: '#3CD6B7',
  primary_100: '#0B5666',
  primary_200: '#13737C',
  primary_300: '#3264FF',
  primary_400: '#3264FF',
  primary_500: '#3CD6B7',
  primary_600: '#6AE6C1',
  primary_700: '#89F2C9',
  primary_800: '#B2FAD7',
  primary_900: '#D8FCE7',
  primary_hover: '#2447B5',

  // secondary
  secondary: '#001F3E',
  secondary_100: '#00081D',
  secondary_200: '#000C23',
  secondary_300: '#00112C',
  secondary_400: '#001735',
  secondary_500: '#001F3E',
  secondary_600: '#225C8B',
  secondary_700: '#4E95C5',
  secondary_800: '#8DCAEB',
  secondary_900: '#C4E6F5',

  // gray
  gray_900: '#151624',

  // red
  red: '#FF424E',
  red_100: '#7A0C3B',
  red_200: '#93153F',
  red_300: '#B72145',
  red_400: '#DB304A',
  red_500: '#FF424E',
  red_600: '#FF7471',
  red_700: '#FF9A8D',
  red_800: '#FFC2B3',
  red_900: '#FFE4D9',

  // orange
  orange: '#FF9F41',
  orange_100: '#7A2C0C',
  orange_200: '#934014',
  orange_300: '#B75C20',
  orange_400: '#DB7B2F',
  orange_500: '#FF9F41',
  orange_600: '#FFBE70',
  orange_700: '#FFD08D',
  orange_800: '#FFE4B3',
  orange_900: '#FFF3D9',

  // blue
  blue: '#1A94FF',
  blue_100: '#042A7A',
  blue_200: '#083C93',
  blue_300: '#0D55B7',
  blue_400: '#1373DB',
  blue_500: '#1A94FF',
  blue_600: '#53B7FF',
  blue_700: '#75CDFF',
  blue_800: '#A3E2FF',
  blue_900: '#D1F3FF',

  // green
  green: '#00AB56',
  green_100: '#00524A',
  green_200: '#00634F',
  green_300: '#007B56',
  green_400: '#009358',
  green_500: '#00AB56',
  green_600: '#33CC70',
  green_700: '#5BE585',
  green_800: '#93F6A7',
  green_900: '#C8FACD',
}
